export default __webpack_public_path__ + "static/media/l22-dropdown.6ebdd71c.webp";